var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/id_ID/phone_number/index.js
 ** module id = 667
 ** module chunks = 0
 **/